import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { FC, useEffect, useState } from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useSelector } from 'react-redux';
import { TFilterFieldProps } from './types';

export const FilterField: FC<TFilterFieldProps> = ({
	filterItem,
	filterList,
	onChange,
	openList,
	anchorEl,
}) => {
	const [options, setOptions] = useState([] as string[]);
	useEffect(() => {
		if (filterList) {
			setOptions([...(filterList ?? [])]);
		}
	}, [filterList]);

	// const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const open = openList;
	const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
		// setAnchorEl(event.currentTarget);
	};

	const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
		setSelectedIndex(index);
		// setAnchorEl(null);
		onChange(options[index]);
	};

	const handleClose = () => {
		// setAnchorEl(null);
	};

	useEffect(() => {
		const index = options.findIndex((item) => item === filterItem);
		setSelectedIndex(index);
	}, [filterItem, options]);

	return (
		<div style={{ width: '150px', marginLeft: '10px' }}>
			<List
				component="nav"
				aria-label="Device settings"
				hidden
				sx={{
					bgcolor: 'background.paper',
					borderRadius: '5px',
					height: '32px',
					m: 0,
					p: '4px',
					w: '100%',
				}}
			>
				<ListItem
					aria-expanded={open ? 'true' : undefined}
					onClick={handleClickListItem}
					sx={{ m: 0, p: 0 }}
					style={{ height: '30px' }}
				>
					<ListItemText sx={{ color: 'black' }} primary={filterItem} />{' '}
					{/* {options[selectedIndex] === ALL_COUNTRIES || filterItem === NO_FILTERS ? (
						<FilterListOffIcon />
					) : (
						<FilterListIcon />
					)} */}
				</ListItem>
			</List>
			<Menu
				id="lock-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'lock-button',
					role: 'listbox',
				}}
				sx={{ left: '-4px', top: '7px', minWidth: '130px' }}
			>
				{options.map((option, index) => (
					<MenuItem
						sx={{ minWidth: '150px' }}
						key={option}
						selected={index === selectedIndex}
						onClick={(event) => handleMenuItemClick(event, index)}
					>
						{/* {option === ALL_COUNTRIES ? (
							<div style={{ color: 'main.primary' }}>All Countries</div>
						) : (
							option
						)} */}
						{option}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};
